import { useSyncExternalStore } from "react";

// The gallery used to give every card its own resize listener (1,186 of them
// on the full gallery). One MediaQueryList, shared by every card, does the
// same job. Same breakpoint as before.
const QUERY = "(max-width: 768px)";

let mql: MediaQueryList | null = null;

const getMql = () => {
  if (!mql && typeof window !== "undefined" && window.matchMedia) {
    mql = window.matchMedia(QUERY);
  }
  return mql;
};

const subscribe = (onChange: () => void) => {
  const m = getMql();
  if (!m) return () => {};
  if (m.addEventListener) {
    m.addEventListener("change", onChange);
    return () => m.removeEventListener("change", onChange);
  }
  // Safari <14
  m.addListener(onChange);
  return () => m.removeListener(onChange);
};

const getSnapshot = () => getMql()?.matches ?? false;

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
